<template>
    <div class="clearfix date-filter">
        <div v-for="option in filter.inputs.mode.options" :key="option.value">
            <div class="form-group">
                <label class="form-label label-auto" :for="option.name">
                    <input type="radio" v-model="mode" :value="option.value" :id="option.value" />
                    {{ option.label }}
                </label>
            </div>

            <div
                class="form-group form-group-32"
                v-if="mode == 'smartdate' && option.value == mode"
            >
                <div class="form-input block">
                    <select class="wp-10" v-model="smartdate" @change="updateView">
                        <option
                            :value="opt.value"
                            v-for="opt in filter.inputs.smartdate.options"
                            :key="opt.value"
                        >
                            {{ opt.label }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group form-group-32" v-if="mode == 'between' && option.value == mode">
                <el-date-picker
                    class="wp-10"
                    v-if="mode == 'between'"
                    v-model="daterange"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :format="datePickerFormat"
                    :range-separator="$t.__('common.labels.to')"
                    :picker-options="pickerOptions"
                    :start-placeholder="$t.__('common.labels.start_date')"
                    :end-placeholder="$t.__('common.labels.end_date')"
                    :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
            </div>

            <div class="form-group form-group-32" v-if="showMinDate && option.value == mode">
                <div class="form-input block">
                    <el-date-picker
                        v-model="start"
                        value-format="yyyy-MM-dd"
                        :format="datePickerFormat"
                        type="date"
                        :picker-options="pickerOptions"
                        :placeholder="$t.__('listing.filters.DateFilter.choose_date')"
                    >
                    </el-date-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListingFilterMixin from './ListingFilterMixin.js';
import DatePicker from 'element-ui';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapState } = createNamespacedHelpers('corp');

export default {
    mixins: [ListingFilterMixin],
    components: {
        DatePicker,
    },

    data() {
        return {
            daterange: '',
            mode: '',
            smartdate: '',
            start: '',
            end: '',
        };
    },

    watch: {
        daterange(newval) {
            if (newval != null) {
                this.start = newval[0];
                this.end = newval[1];
            } else {
                this.start = '';
                this.end = '';
            }
        },
    },

    created() {
        if (this.mode == 'between' && this.start && this.end) {
            this.daterange = [this.start, this.end];
        }
    },

    computed: {
        showMinDate() {
            return this.mode == 'equals' || this.mode == 'after' || this.mode == 'before';
        },

        data() {
            return {
                mode: this.mode,
                smartdate: this.smartdate,
                start: this.start,
                end: this.end,
            };
        },

        pickerOptions() {
            return {
                firstDayOfWeek: this.timeformat == 'dmy' ? 1 : 7,
            };
        },

        ...mapGetters(['datePickerFormat']),

        ...mapState(['timeformat']),
    },

    methods: {
        updateView() {
            this.$forceUpdate();
        },
    },
};
</script>

<style lang="sass" scoped>
.date-filter {
	&::v-deep {
		.el-date-editor {
			.el-range-separator {
				height: auto;
			}
		}
	}
}

.el-picker-panel__body {
	margin-left: 0px !important;
}
</style>
